import colors from 'vuetify/lib/util/colors';

export const light = {
  primary: '#a6ce39', //colors.lime.darken2,
  secondary: '#618EC1',
  accent: colors.lime.darken2,
  error: '#f44336',
  warning: '#ffc107',
  info: '#2196f3',
  success: '#4caf50',
};
